import { render } from "./Header.vue?vue&type=template&id=2ecdb9d5&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=2ecdb9d5&scoped=true&lang=css"

import exportComponent from "D:\\GitHub\\lexoh-parking-ionic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecdb9d5"]])

export default __exports__